import { Phone, MessageCircle } from "lucide-react";
import { telLink, waLink } from "../../lib/site";

export default function StickyCTA() {
  return (
    <div className="fixed bottom-0 left-0 z-40 grid w-full grid-cols-2 border-t border-white/10 bg-ink/90 backdrop-blur-md sm:hidden" data-testid="sticky-cta">
      <a href={telLink} data-testid="sticky-call" className="flex items-center justify-center gap-2 border-r border-white/10 py-4 text-sm font-bold uppercase tracking-wider text-white">
        <Phone size={16} /> Call Now
      </a>
      <a href={waLink()} target="_blank" rel="noreferrer" data-testid="sticky-whatsapp" className="flex items-center justify-center gap-2 bg-volt py-4 text-sm font-bold uppercase tracking-wider text-ink">
        <MessageCircle size={16} /> WhatsApp
      </a>
    </div>
  );
}
